import { useState } from 'react'
import { useSyncOnChange } from '~/hooks/use-sync-on-change'

/**
 * Option active d'une liste pilotée au clavier (#109) : les flèches la
 * déplacent en boucle, et elle revient sur la première quand les résultats
 * changent (`resetKey`, la recherche) — Entrée ouvre alors le meilleur
 * résultat, sans avoir à descendre dessus.
 *
 * Sans option, aucune n'est active (-1) : `aria-activedescendant` ne doit pas
 * désigner un élément qui n'existe pas.
 */
export function useActiveOption(count: number, resetKey: string) {
  const [index, setIndex] = useState(0)
  useSyncOnChange(resetKey, () => setIndex(0))

  const activeIndex = count === 0 ? -1 : Math.min(index, count - 1)
  const move = (delta: number) => {
    if (count === 0) return
    setIndex(current => (Math.min(current, count - 1) + delta + count) % count)
  }

  return { activeIndex, move, setActiveIndex: setIndex }
}
